import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { MyAttendance } from "@/components/staff/attendance/MyAttendance";
import { AttendanceReport } from "@/components/staff/attendance/AttendanceReport";
import { MonthlyAttendance } from "@/components/staff/attendance/MonthlyAttendance";
import { MyShiftSchedule } from "@/components/staff/attendance/MyShiftSchedule";
import { WeeklySchedule } from "@/components/staff/attendance/WeeklySchedule";
import { ShiftRequestsAdmin } from "@/components/staff/attendance/ShiftRequestsAdmin";

export const AttendancePanel = () => {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);
  const [rev, setRev] = useState(0);
  const [reportRev, setReportRev] = useState(0);

  useEffect(() => {
    api.get("/attendance/config").then((r) => setConfig(r.data));
  }, []);

  if (!config) return <Loader2 className="w-6 h-6 animate-spin text-forest" />;
  return (
    <div data-testid="attendance-panel">
      <h2 className="font-serif font-semibold text-2xl mb-1">Absensi</h2>
      <p className="text-sm text-muted2 mb-5">
        Buka 24 jam · {config.shifts.map((s) => `${s.label} ${s.start}–${s.end}`).join(" · ")}
      </p>
      <MyAttendance config={config} />
      <MyShiftSchedule config={config} me={user} />
      {user.role === "admin" && <ShiftRequestsAdmin config={config} onChanged={() => setRev((x) => x + 1)} />}
      {user.role === "admin" && <WeeklySchedule key={rev} config={config} onChanged={() => setReportRev((x) => x + 1)} />}
      {user.role === "admin" && <AttendanceReport key={`r${rev}-${reportRev}`} config={config} />}
      {user.role === "admin" && <MonthlyAttendance config={config} />}
    </div>
  );
};
